var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 149,
    viewBox: "0 0 176 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7857 58.625H137.214C138.746 58.625 140 59.8801 140 61.4141V121.844C140 128.003 135.009 133 128.857 133H47.1429C40.9911 133 36 128.003 36 121.844V61.4141C36 59.8801 37.2536 58.625 38.7857 58.625ZM140 48.3984V40.0312C140 33.8721 135.009 28.875 128.857 28.875H117.714V16.7891C117.714 15.2551 116.461 14 114.929 14H105.643C104.111 14 102.857 15.2551 102.857 16.7891V28.875H73.1429V16.7891C73.1429 15.2551 71.8893 14 70.3571 14H61.0714C59.5393 14 58.2857 15.2551 58.2857 16.7891V28.875H47.1429C40.9911 28.875 36 33.8721 36 40.0312V48.3984C36 49.9324 37.2536 51.1875 38.7857 51.1875H137.214C138.746 51.1875 140 49.9324 140 48.3984Z",
    fill: "#FFABAB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.8905,
    width: 214.511,
    height: 15.5789,
    rx: 7.78944,
    transform: "rotate(39.4102 9.8905 0)",
    fill: "#FFD5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/no-access.fa336fcdf4f051dc66876454d0133aed.svg";
export { ForwardRef as ReactComponent };